// composables/useBackgroundActions.js
import { computed } from 'vue'
import { useStore } from 'vuex'

export function useBackgroundActions() {
    const store = useStore()

    const backgroundActions = computed(() => store.getters.backgroundActions)

    const getBackgroundActionById = (id) => {
        return store.getters.getBackgroundActionById(id)
    }

    /**
     * Find an existing in-progress background action by metadata
     * Useful for reconnecting to jobs after component remount
     */
    const findBackgroundAction = (matchFn) => {
        return store.getters.backgroundActions.find(
            (action) => action.status === 'in-progress' && matchFn(action)
        )
    }

    const addBackgroundAction = async (updates) => {
        // dispatch returns a Promise that resolves to the action's return value (the id)
        return await store.dispatch('addBackgroundAction', updates)
    }

    const updateBackgroundAction = (id, updates) => {
        store.dispatch('updateBackgroundAction', { id, updates })
    }

    const startPolling = (id, pollUrl, { onComplete, onFail } = {}) => {
        store.dispatch('startPolling', { id, pollUrl, onComplete, onFail })
    }

    const stopPolling = (id) => {
        store.dispatch('stopPolling', id)
    }

    const completeBackgroundAction = (id, { resultId, navigateTo, navigateToQueryParams } = {}) => {
        store.dispatch('completeBackgroundAction', { id, resultId, navigateTo, navigateToQueryParams })
    }

    const failBackgroundAction = (id, error, { resultId, navigateTo, navigateToQueryParams } = {}) => {
        store.dispatch('failBackgroundAction', { id, error, resultId, navigateTo, navigateToQueryParams })
    }

    const removeBackgroundAction = (id) => {
        store.dispatch('removeBackgroundAction', id)
    }

    /**
     * Show the toast for an action (unsuppress it)
     * Called when user navigates away from a dedicated progress page
     */
    const showBackgroundActionToast = (id) => {
        store.dispatch('showBackgroundActionToast', id)
    }

    return {
        backgroundActions,
        getBackgroundActionById,
        findBackgroundAction,
        addBackgroundAction,
        updateBackgroundAction,
        startPolling,
        stopPolling,
        completeBackgroundAction,
        failBackgroundAction,
        removeBackgroundAction,
        showBackgroundActionToast,
    }
}
